module.exports = __webpack_public_path__ + "img/activity.aa529c25.jpg";